<template>
  <div class="resume-header">
    <div class="row align-items-center">
      <div class="resume-title col-12 col-md-6 col-lg-8 col-xl-9">
        <h2 class="resume-name mb-0 text-uppercase">Vyzaldy Sanchez</h2>
        <div class="resume-tagline mb-3 mb-md-0">Software Engineer</div>
      </div>
      <!--//resume-title-->
      <div class="resume-contact col-12 col-md-6 col-lg-4 col-xl-3">
        <ul class="list-unstyled mb-0">
          <li class="mb-2"><i class="fas fa-envelope-square fa-fw fa-lg mr-2"></i><a class="resume-link" href="mailto:vyzaldysanchez@gmail.com">vyzaldysanchez@gmail.com</a></li>
          <li class="mb-0"><i class="fas fa-map-marker-alt fa-fw fa-lg mr-2"></i>SANTO DOMINGO, DOMINICAN REPUBLIC</li>
        </ul>
      </div>
      <!--//resume-contact-->
    </div>
    <!--//row-->
  </div>
</template>

<script>
export default {
  name: 'Presentation',

  data () {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Presentation.vue